import React from 'react';

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
    children: React.ReactNode; // can contain anything
}

// Creating a Card component that can be reused
export const Card = ({ children, className, ...props }: CardProps) => {
    const baseStyles = 'border rounded-lg p-6 shadow-sm'; 
    const combinedStyles = `${baseStyles} ${className || ''}`;
    
    return(
        <div className={combinedStyles} {...props}>
            {children}
        </div>
    );
};